var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "+_vm._s(_vm.nested.level)+"\n    "),_c('v-btn',{on:{"click":_vm.getRandomText}},[_vm._v("\n        Go\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }